import React, {useEffect} from 'react';
import "./adl-app.style.css";
import {BrowserRouter, Route, Switch, useHistory} from "react-router-dom";
import {ConfigProvider} from "antd";
import StaticScreen from "./module/static-web-page/screens/staticWeb.screen";

function AdlApp() {

    ConfigProvider.config({
        theme: {
            primaryColor: '#C40E42',
        },
    });

    return (
        <BrowserRouter>
            <Switch>
                <ConfigProvider>
                    <Route path="/" exact component={StaticScreen}/>
                    <Route path="*" component={NoMatch}/>
                </ConfigProvider>
            </Switch>
        </BrowserRouter>
    );
}

const NoMatch = () => {

    const history = useHistory();

    useEffect(()=>{
        history.push(`/`);
    },[])
    return (
        <div></div>
    )
}

export default AdlApp;
